module.exports = __webpack_public_path__ + "img/cookie.38d20a13.png";